var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_889_819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.65992L11.3416 0.501817C10.9938 0.153887 10.5314 -0.0375977 10.0397 -0.0375977C9.54793 -0.0375977 9.08555 0.153887 8.73766 0.501817L0.5835 8.65582L0.575258 8.66422C-0.138845 9.38246 -0.137634 10.5478 0.578774 11.2642C0.906079 11.5916 1.33819 11.7811 1.80038 11.8011C1.81929 11.803 1.83829 11.8039 1.85729 11.8039H2.18229V17.8076C2.18229 18.9958 3.14909 19.9624 4.3373 19.9624H7.52914C7.85277 19.9624 8.11508 19.7 8.11508 19.3765V14.6695C8.11508 14.1273 8.55621 13.6863 9.09836 13.6863H10.981C11.5231 13.6863 11.9641 14.1273 11.9641 14.6695V19.3765C11.9641 19.7 12.2264 19.9624 12.55 19.9624H15.7419C16.9303 19.9624 17.8969 18.9958 17.8969 17.8076V11.8039H18.1984C18.6901 11.8039 19.1524 11.6124 19.5005 11.2643C20.2176 10.5469 20.2179 9.37941 19.5015 8.66148L19.5 8.65992Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_889_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3213b670ac577812e06feace9e9e061f.svg";
export { ForwardRef as ReactComponent };